import React from 'react';
import { SideBar } from '../sidebar';
import { getAllAuctionsByGroup, getAllBiddersByGroup } from '../../../models/auctions';
import { getGroupsList } from '../../../models/groups';
import DataTable from 'react-data-table-component';
import i18n from '../../../i18n';
import { apiUrl } from '../../../constants/global';
import { getLoggedUser } from '../../../state/user';
import { tableStyles } from '../../../styles/components/js/tableStyle';
import NoData from '../../common/NoData';
import { TableSkeleton } from '../../common/skelton/TableSkelton';
import HeaderBanner from '../../common/HeaderBanner';

const user = getLoggedUser();

export class Reports extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {
        auction: '',
        group: '',
        downloadType: '',
      },
      groups: [],
      titles: [],
      bidders: [],
      phone_loader: false,
      searched: false,
      bidder_loading: false,

      // FIX 1: Added missing pagination state variables
      total: 0,
      limit: 15,
      page: 1,

      customStyles: {
        headCells: {
          style: {
            fontWeight: 'bold',
            backgroundColor: '#e4f7ff',
            color: '#000000',
          },
        },
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.loadAuctions = this.loadAuctions.bind(this);
    this.searchSubmit = this.searchSubmit.bind(this);

    // FIX 2: Bind the previously missing handlers
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this);
    this.downloadDoc = this.downloadDoc.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadAllGroups();
  }

  // FIX 3: Moved columns out of state — they are static and belong as a class method
  getColumns() {
    return [
      {
        name: i18n.t('bidder_id'),
        selector: (row) => row.id,
        sortable: true,
        wrap: true,
      },
      {
        name: 'Name',
        selector: (row) => row.user?.name,
        cell: (row) => <span>{row.user?.name || '-'}</span>,
      },
      {
        name: i18n.t('username'),
        selector: (row) => row.user?.username,
        cell: (row) => <span>{row.user?.username || '-'}</span>,
      },
      {
        name: i18n.t('latest_bid_amount'),
        selector: (row) => row.bid_amount,
        sortable: true,
      },
      {
        name: 'Bid Date',
        selector: (row) => row.created_at,
        sortable: true,
      },
      {
        name: i18n.t('title'),
        selector: (row) => row.auction?.title,
        cell: (row) => <span>{row.auction?.title || '-'}</span>,
      },
      {
        name: i18n.t('group'),
        selector: (row) => row.auction?.group_relation?.group_name,
        cell: (row) => <span>{row.auction?.group_relation?.group_name || '-'}</span>,
      },
      {
        name: i18n.t('start_date'),
        selector: (row) => row.auction?.start_date,
        wrap: true,
        cell: (row) => <span>{row.auction?.start_date || '-'}</span>,
      },
      {
        name: i18n.t('end_date'),
        selector: (row) => row.auction?.end_date,
        wrap: true,
        cell: (row) => <span>{row.auction?.end_date || '-'}</span>,
      },
    ];
  }

  handleChange(event) {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      input: {
        ...prevState.input,
        [name]: value,
      },
    }));

    if (name === 'group') {
      // Reset auction selection when group changes
      this.setState((prevState) => ({
        input: { ...prevState.input, group: value, auction: '' },
        titles: [],
        bidders: [],
        searched: false,
      }));
      this.loadAuctions(value);
    }
  }

  async loadAllGroups() {
    try {
      const response = await getGroupsList();
      this.setState({ groups: response.data || [] });
    } catch (error) {
      console.error('Failed to load groups:', error);
      this.setState({ groups: [] });
    }
  }

  async loadAuctions(group) {
    if (!group) return;

    try {
      this.setState({ phone_loader: true });
      const response = await getAllAuctionsByGroup(group);
      this.setState({
        titles: response.data || [],
        phone_loader: false,
      });
    } catch (error) {
      console.error('Failed to load auctions:', error);
      this.setState({ phone_loader: false, titles: [] });
    }
  }

  async searchSubmit() {
    try {
      this.setState({ bidder_loading: true, searched: true });
      const response = await getAllBiddersByGroup(this.state.input);
      const data = response.data || [];

      this.setState({
        bidders: data,
        bidder_loading: false,
        // FIX 4: Properly set total for pagination
        total: data.length,
        page: 1,
      });
    } catch (error) {
      console.error('Failed to load bidders:', error);
      this.setState({ bidder_loading: false, bidders: [] });
    }
  }

  // FIX 5: Added missing pagination handlers
  onChangePage(page) {
    this.setState({ page });
  }

  onChangeRowsPerPage(limit, page) {
    this.setState({ limit, page });
  }

  // FIX 6: Added missing downloadDoc handler (was referenced but never defined)
  downloadDoc(event) {
    event.preventDefault();
    // Download is handled via the <a> tag href; this prevents default form submission
  }

  // FIX 7: handleRefresh as a proper function reference (not called immediately)
  handleRefresh() {
    if (this.state.input.group) {
      this.searchSubmit();
    }
  }

  render() {
    const { groups, titles, bidders, input, phone_loader, bidder_loading, searched } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('report')} />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                <SideBar />
              </div>
              <div className="col-xl-9 col-lg-12 col-md-12">
                {/* Search Form */}
                <div className="card mb-0">
                  <div className="card-header">
                    <h3 className="card-title">{i18n.t('search')}</h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Group Selector */}
                      <div className="col-sm-12 col-md-5">
                        <div className="form-group">
                          <label className="form-label">{i18n.t('auction_group')}</label>
                          <select
                            className="form-control"
                            name="group"
                            value={input.group}
                            onChange={this.handleChange}
                          >
                            <option value="">--{i18n.t('group')}--</option>
                            {groups.map((item) => (
                              <option value={item.id} key={item.id}>
                                {item.group_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Auction Selector */}
                      <div className="col-sm-12 col-md-5">
                        <div className="form-group">
                          <label className="form-label">{i18n.t('auction_name')}</label>
                          <div className="input-group">
                            <select
                              className="form-control"
                              name="auction"
                              value={input.auction}
                              onChange={this.handleChange}
                              disabled={!input.group}
                            >
                              <option value="">--{i18n.t('auction')}--</option>
                              {titles.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {item.title}
                                </option>
                              ))}
                            </select>

                            {phone_loader && (
                              <span
                                className="input-group-addon"
                                style={{
                                  position: 'absolute',
                                  marginLeft: '54%',
                                  marginTop: '10px',
                                }}
                              >
                                <i className="fa fa-refresh fa-spin"></i>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Search Button */}
                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">
                          <label className="form-label">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            disabled={!input.group || bidder_loading}
                            onClick={this.searchSubmit}
                          >
                            {bidder_loading ? (
                              <i className="fa fa-spinner fa-spin" />
                            ) : (
                              i18n.t('search')
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />

                {/* Results Card */}
                <div className="card mb-0">
                  <div className="card-header">
                    <h3 className="card-title" style={{ width: '65%' }}>
                      {i18n.t('result')}
                    </h3>

                    {/* FIX 8: downloadDoc is now a defined bound method */}
                    {bidders.length > 0 && (
                      <form
                        className="form-inline"
                        style={{ width: '35%' }}
                        onSubmit={this.downloadDoc}
                      >
                        <div className="form-group mx-sm-3">
                          <select
                            className="form-control"
                            name="downloadType"
                            value={input.downloadType}
                            onChange={this.handleChange}
                          >
                            <option value="">Download As</option>
                            <option value="pdf">PDF</option>
                            <option value="excel">Excel</option>
                          </select>
                        </div>
                        {input.downloadType !== '' && (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                              `${apiUrl}bidder_report/export` +
                              `?q=${input.downloadType}` +
                              `&group=${input.group}` +
                              `&auction=${input.auction}` +
                              `&u=${user.role}`
                            }
                            className="btn btn-outline-danger"
                          >
                            {i18n.t('download')}
                          </a>
                        )}
                      </form>
                    )}
                  </div>

                  <div className="card-body">
                    <div className="Data-Listing">
                      {/* FIX 9: Use bidder_loading (not the never-set is_loading) */}
                      {bidder_loading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : bidders.length > 0 ? (
                        <DataTable
                          responsive={true}
                          // FIX 10: getColumns() is now a defined class method
                          columns={this.getColumns()}
                          data={bidders}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          // FIX 11: Removed paginationServer — data is already local after fetch
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        // FIX 12: onAction now passes a function reference, not an immediate call
                        searched && (
                          <NoData
                            message={i18n.t('no_data_available')}
                            actionText={i18n.t('refresh')}
                            onAction={this.handleRefresh}
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
